import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Map from '@location/containers/Map';
import MapPositionModel, {
  ICON,
  ICON_SIZE,
  ICON_SIZE_X,
  ICON_SIZE_Y,
  ID,
  LATITUDE,
  LONGITUDE,
} from '@location/containers/Map/models/MapPosition';
import partnerIcon from '@assets/icons/partner.svg';

const Container = styled.div`
  position: relative;
  height: 112px;
  background: ${({ theme }) => theme.colors.corporateWhite};
  transition: height 0.3s;
  height: ${({ expanded }) => (expanded ? '70vh' : '112px')};
  border-radius: 4px;
  margin-bottom: 16px;
`;

function ShopInfoMap({ isMapExpanded, latitude, longitude, onClick }) {
  const points = useMemo(
    () => [
      MapPositionModel({
        [ID]: 1,
        [LATITUDE]: latitude,
        [LONGITUDE]: longitude,
        [ICON]: partnerIcon,
        [ICON_SIZE]: {
          [ICON_SIZE_X]: 80,
          [ICON_SIZE_Y]: 80,
        },
      }),
    ],
    [latitude, longitude],
  );

  return (
    <Container expanded={isMapExpanded} onClick={onClick}>
      <Map
        markers={points}
        zoom={13}
        isEditable={false}
        fullScreen={false}
        shouldCenter
        icon
      />
    </Container>
  );
}

ShopInfoMap.propTypes = {
  isMapExpanded: PropTypes.bool.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ShopInfoMap;
